var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3295_395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8044 12.8033C15.7334 9.87437 15.7334 5.12563 12.8044 2.1967C9.8755 -0.732232 5.12676 -0.732233 2.19783 2.1967C-0.7311 5.12563 -0.7311 9.87437 2.19783 12.8033C5.12676 15.7322 9.8755 15.7322 12.8044 12.8033Z",
    fill: "#515CD1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0958 4.62131L10.0222 11.0939C9.97104 11.4027 9.55734 11.5025 9.26943 11.2784C8.39293 10.5963 7.5541 9.94366 6.75059 9.31878C6.39171 9.0394 6.33621 8.56728 6.62177 8.26806C7.29176 7.56615 7.96544 6.86094 8.6425 6.15175C8.76022 6.02876 8.56682 5.85915 8.41883 5.95404C7.36205 6.63248 6.32511 7.29769 5.30769 7.95067C5.0894 8.09085 4.8052 8.11036 4.56269 8.00357C3.99462 7.75362 3.44134 7.51061 2.90286 7.27388C2.61058 7.14527 2.63984 6.74357 2.94624 6.64504L10.4651 4.22621C10.7883 4.1224 11.1415 4.34127 11.0951 4.62098L11.0958 4.62131Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3295_395"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.229060b253d56ad17fe890139d45389a.svg";
export { ForwardRef as ReactComponent };